export default {
  // productsCtx: require.context("../src/products", false, /.product.(jsx)$/),
};
